import logo from "../assets/images/svg/25th-and-staffing-logo-.svg";
import logoWhite from "../assets/images/png/logo-white.png";
import logo2 from "../assets/images/svg/logo.png";
import thanks from "../assets/images/svg/icons/thanks.svg";
import icon1 from "../assets/images/svg/icons/icon1.svg";
import icon2 from "../assets/images/svg/icons/icon2.svg";
import icon3 from "../assets/images/svg/icons/icon3.svg";
import add from "../assets/images/svg/icons/add.svg";
import add2 from "../assets/images/svg/icons/add2.svg";
import remove from "../assets/images/svg/icons/remove2.svg";
import eben from "../assets/images/png/eben.png";
import users from "../assets/images/svg/icons/users.svg";
import heroImage from "../assets/images/svg/25th-ai-user.svg";
import star from "../assets/images/svg/icons/star.svg";
import video from "../assets/images/svg/icons/video.svg";
import security from "../assets/images/svg/icons/security.svg";
import time from "../assets/images/svg/icons/time.svg";
import eye from "../assets/images/svg/icons/eye.svg";
import insight from "../assets/images/svg/icons/insight.svg";
import book from "../assets/images/svg/icons/book.svg";
import userx from "../assets/images/svg/icons/userx.svg";
import complex from "../assets/images/svg/icons/complex.svg";
import calendar from "../assets/images/svg/icons/calendar.svg";
import check from "../assets/images/svg/icons/check.svg";
import volks from "../assets/images/png/volks.png";
import step1 from "../assets/images/svg/icons/step1.svg";
import step2 from "../assets/images/svg/icons/step2.svg";
import step3 from "../assets/images/svg/icons/step3.svg";
import step4 from "../assets/images/svg/icons/step4.svg";
import emailVerify from "../assets/images/svg/icons/email_verify.svg";
import checkmark from "../assets/images/svg/icons/checkmark.svg";
import error from "../assets/images/svg/icons/error.svg";
import paypal from "../assets/images/svg/paypal.svg";
import paystack from "../assets/images/svg/paystack.svg";
import bankTransfer from "../assets/images/svg/bank-transfer.svg";
import crystalline from "../assets/images/png/crystalline.png";
import avatar from "../assets/images/jpg/avatar.jpeg";
import atsuSign from "../assets/images/png/atsu-sign.png";
import ceoSign from "../assets/images/jpg/ceo-signature.jpg";
import {
  BrainCircuit,
  CalendarRange,
  ChartNoAxesColumn,
  NotebookText,
  ShieldCheck,
  Video,
} from "lucide-react";
// import {
//   AiBrain04Icon,
//   Calendar02Icon,
//   Chart01Icon,
//   Notebook02Icon,
//   SecurityIcon,
//   Video01Icon,
// } from "@hugeicons/core-free-icons";

const img = {
  logo: logo,
  logoWhite: logoWhite,
  logo2: logo2,
  thanks: thanks,
  icon1: icon1,
  icon2: icon2,
  icon3: icon3,
  add: add,
  add2: add2,
  remove: remove,
  eben: eben,
  users: users,
  heroImage: heroImage,
  star: star,
  video: video,
  security: security,
  calendar: calendar,
  volks: volks,
  check: check,
  checkmark: checkmark,
  emailVerify: emailVerify,
  error: error,
  paypal: paypal,
  paystack: paystack,
  bankTransfer: bankTransfer,
  crystalline: crystalline,
  avatar: avatar,
  atsuSign: atsuSign,
  ceoSign: ceoSign,

  competenceArea: [
    {
      id: 1,
      title: "Communication Skills",
      comments:
        "Ebenezer provided concise answers but could elaborate more on his background and experiences.",
      score: "58",
      rating: "Good",
    },
    {
      id: 2,
      title: "Technical Knowledge",
      comments:
        "Discussed an HR automated process project but lacked detailed technical insights.",
      score: "74",
      rating: "Good",
    },
    {
      id: 3,
      title: "Problem Solving",
      comments:
        "Demonstrated ability to navigate challenges in project planning and execution.",
      score: "68",
      rating: "Good",
    },
    {
      id: 4,
      title: "Cultural Fit",
      comments:
        "Expressed alignment with career goals and demonstrated teamwork as a key strength.",
      score: "55",
      rating: "Good",
    },
    {
      id: 5,
      title: "Experience Relevance",
      comments:
        "Experience with HR processes is relevant, but more detail on specific roles and outcomes would be helpful.",
      score: "80",
      rating: "Good",
    },
  ],
  cards: [
    // {
    //   id: 1,
    //   icon: time,
    //   text: "Manual interviews consume 40+ hours per week",
    //   subtitle:
    //     "Traditional interview processes are time-intensive and inconsistent",
    // },
    // {
    //   id: 2,
    //   icon: eye,
    //   text: "Subjective evaluations lead to hiring mistakes",
    //   subtitle:
    //     "Human bias and inconsistent assessment criteria affect quality",
    // },
    {
      id: 1,
      icon: insight,
      text: "Limited insights into candidate behavior",
      subtitle: "Missing crucial behavioral and communication patterns",
    },
    {
      id: 2,
      icon: book,
      text: "Inconsistent interview questions across roles",
      subtitle: "Lack of standardized, role-specific interview processes",
    },
    // {
    //   id: 5,
    //   icon: userx,
    //   text: "High candidate drop-off rates",
    //   subtitle: "Poor scheduling experience leads to lost talent",
    // },
    {
      id: 3,
      icon: complex,
      text: "Complex coordination between stakeholders",
      subtitle: "Manual scheduling creates bottlenecks and delays",
    },
  ],

  lifeOfHr: [
    { id: 1, number: "1", text: "Manual interview coordination: 8 hours/week" },
    {
      id: 2,
      number: "2",
      text: "Inconsistent candidate evaluations: 6 hours/week",
    },
    { id: 3, number: "3", text: "Rescheduling and follow-ups: 4 hours/week" },
    {
      id: 4,
      number: "4",
      text: "Report compilation and analysis: 5 hours/week",
    },
    {
      id: 5,
      number: "5",
      text: "Managing no-shows and cancellations: 3 hours/week",
    },
  ],

  coreFeatures: [
    {
      id: 1,
      icon: BrainCircuit,
      // icon: AIBrain01Icon,
      text: "AI-Autonomous Interviews",
      subtitle:
        "Fully automated AI interviews or human-AI hybrid approach for balanced evaluations.",
      icon2: check,
      core1: "100% AI-conducted interviews for high-volume hiring",
      core2: "Human-AI hybrid mode for nuanced evaluations",
      core3: "Adaptive questioning based on candidate responses",
      core4: "Real-time conversation flow optimization",
    },
    {
      id: 2,
      icon: Video,
      // icon: Video01Icon,
      text: "Behavioral Tracking & Analysis",
      subtitle:
        "Fully automated AI interviews or human-AI hybrid approach for balanced evaluations.",
      icon2: check,
      core1: "Real-time facial expression analysis",
      core2: "Voice tone and speech pattern recognition",
      core3: "Body language and engagement tracking",
      core4: "Confidence and communication skill assessment",
    },
    {
      id: 3,
      icon: NotebookText,
      // icon: Notebook02Icon,
      text: "Smart Job Description System",
      subtitle:
        "Fully automated AI interviews or human-AI hybrid approach for balanced evaluations.",
      icon2: check,
      core1: "Role-specific question generation",
      core2: "Skills-based interview customization",
      core3: "Industry best practice integration",
      core4: "Consistent evaluation criteria across roles",
    },
    {
      id: 4,
      icon: ChartNoAxesColumn,
      // icon: Chart01Icon,
      text: "AI Grading & Reporting",
      subtitle:
        "Fully automated AI interviews or human-AI hybrid approach for balanced evaluations.",
      icon2: check,
      core1: "Automated candidate scoring (0-100 scale)",
      core2: "Detailed behavioral analysis reports",
      core3: "Comparative candidate analytics",
      core4: "Data-driven hiring recommendations",
    },
    {
      id: 5,
      icon: CalendarRange,
      // icon: Calendar02Icon,
      text: "Flexible Rescheduling",
      subtitle:
        "Fully automated AI interviews or human-AI hybrid approach for balanced evaluations.",
      icon2: check,
      core1: "One-click rescheduling up to interview time",
      core2: "Automated stakeholder notifications",
      core3: "Buffer time management and conflict resolution",
      core4: "Candidate self-service rescheduling portal",
    },
    {
      id: 6,
      icon: ShieldCheck,
      // icon: SecurityIcon,
      text: "Enterprise Security",
      subtitle:
        "Fully automated AI interviews or human-AI hybrid approach for balanced evaluations.",
      icon2: check,
      core1: "End-to-end encryption (E2EE) for all data",
      core2: "AES-256 encryption for stored content",
      core3: "TLS 1.2+ secure transmission",
      core4: "Geographically distributed encrypted backups",
    },
  ],

  aIAutonomous: [
    {
      id: 1,
      icon: check,
      text: "100% AI-conducted interviews for high-volume hiring",
    },
    {
      id: 1,
      icon: check,
      text: "Human-AI hybrid mode for nuanced evaluations",
    },
    {
      id: 1,
      icon: check,
      text: "Adaptive questioning based on candidate responses",
    },
    { id: 1, icon: check, text: "Real-time conversation flow optimization" },
  ],

  comparisonData: [
    {
      label: "Interview setup time",
      traditional: "2 hours",
      aiPowered: "5 minutes",
      traditionalColor: "text-[#FF3131]",
      aiPoweredColor: "text-[#16A34A]",
    },
    {
      label: "Evaluation consistency",
      traditional: "60%",
      aiPowered: "95%",
      traditionalColor: "text-[#FF3131]",
      aiPoweredColor: "text-[#16A34A]",
    },
    {
      label: "Behavioral insights",
      traditional: "Limited",
      aiPowered: "Comprehensive",
      traditionalColor: "text-[#FF3131]",
      aiPoweredColor: "text-[#16A34A]",
    },
    {
      label: "Hiring speed",
      traditional: "2-4 weeks",
      aiPowered: "3-5 days",
      traditionalColor: "text-[#FF3131]",
      aiPoweredColor: "text-[#16A34A]",
    },
  ],

  simpleSteps: [
    {
      id: 1,
      icon: step1,
      number: "1",
      title: "Signup & Integration",
      subtitle: "Sign-up and connect your existing tools",
      text: "5-minute setup with calendar and ATS integration",
    },
    {
      id: 2,
      icon: step2,
      number: "2",
      title: "Create Job Profile",
      subtitle: "AI generates role-specific interview questions",
      text: "Smart job description analysis and question optimization",
    },
    {
      id: 3,
      icon: step3,
      number: "3",
      title: "AI Interviews",
      subtitle: "Autonomous AI or hybrid interviews with behavioral tracking",
      text: "Real-time analysis of communication and engagement",
    },
    {
      id: 4,
      icon: step4,
      number: "4",
      title: "Get Insights",
      subtitle: "Receive comprehensive reports and hiring recommendations",
      text: "AI-powered scoring and comparative candidate analysis",
    },
  ],

  faqData: [
    {
      id: 1,
      question: "Is my data secure",
      answer:
        "Absolutely! We use end-to-end encryption (E2EE), AES-256 encryption for stored data, TLS 1.2+ for transmission, and maintain geographically distributed encrypted backups. We're GDPR-compliant with SOC 2 Type II certification.",
    },
    {
      id: 2,
      question: "How does AI-autonomous interviewing work",
      answer:
        "Our AI-autonomous interviewing system uses advanced natural language processing to conduct realistic interviews. The AI adapts to candidate responses, asks follow-up questions, and maintains a conversational flow similar to human interviewers while ensuring consistency across all candidates.",
    },
    {
      id: 3,
      question: "What behavioral insight does the system provide",
      answer:
        "The system analyzes communication patterns, response timing, confidence levels, and behavioral indicators. It provides insights on leadership potential, teamwork abilities, problem-solving approaches, and cultural fit based on validated psychological frameworks.",
    },
    {
      id: 4,
      question: "Can I customize interviews for different roles",
      answer:
        "Yes, you can fully customize interviews for different positions. Create role-specific question sets, adjust difficulty levels, set custom evaluation criteria, and tailor the interview flow to match your specific requirements for each role.",
    },
    {
      id: 5,
      question: "How accurate is the AI grading system",
      answer:
        "Our AI grading system maintains 94% accuracy compared to human evaluators. It's been trained on thousands of interview scenarios and continuously learns from feedback to improve assessment quality while eliminating human bias.",
    },
    // {
    //   id: 6,
    //   question: "How quickly can I get started",
    //   answer:
    //     "You can get started immediately! Sign up takes less than 2 minutes, and you can launch your first interview within 5 minutes. Our intuitive setup wizard guides you through creating your first interview template.",
    // },
    // {
    //   id: 7,
    //   question: "What's included in the free trial",
    //   answer:
    //     "The free trial includes 10 candidate interviews, access to all core features, basic analytics dashboard, email support, and full access to our interview customization tools. No credit card required to start.",
    // },
    {
      id: 6,
      question: "How does the job description system work",
      answer:
        "Simply paste or upload your job description, and our AI automatically generates relevant interview questions, creates assessment criteria, and suggests competency frameworks. The system learns from your preferences to improve future recommendations.",
    },
    {
      id: 7,
      question: "Can candidates reschedule their interviews",
      answer:
        "Yes, candidates can reschedule interviews through their personalized link up to 24 hours before the scheduled time. They'll receive automatic confirmation emails, and you'll be notified of any changes to maintain your hiring workflow.",
    },
  ],
  simpleStep: [
    {
      id: 1,
      icon: users,
      icon2: checkmark,
      number: "1",
      title: "Starter",
      text1: "Max Admin - 1",
      text2: "Monthly Interviews - 3",
      display: "hidden",
      tier: "STARTER" as const,
    },
    {
      id: 2,
      icon: users,
      icon2: checkmark,
      number: "2",
      title: "Growth",
      text1: "Max Admin - 5",
      text2: "Monthly Interviews - 100",
      display: "block",
      tier: "GROWTH" as const,
    },
    {
      id: 3,
      icon: users,
      icon2: checkmark,
      number: "3",
      title: "Scale",
      text1: "Max Admin - 20",
      text2: "Monthly Interviews - 500",
      display: "block",
      tier: "SCALE" as const,
    },
    {
      id: 4,
      icon: users,
      icon2: checkmark,
      number: "4",
      title: "Enterprise",
      text1: "Max Admin - 20",
      text2: "Monthly Interviews - 500",
      display: "block",
      tier: "ENTERPRISE" as const,
    },
  ],

  collectionSteps: [
    {
      step: "1",
      action: "First Reminder",
      timing: "Day 1 overdue",
      notes:
        "Friendly reminder referencing payment due and 3-day grace period.",
    },
    {
      step: "2",
      action: "Second Reminder",
      timing: "Day 4",
      notes:
        "Formal reminder warning of service suspension, Reactivation Fee, and accruing interest.",
    },
    {
      step: "3",
      action: "Demand Letter",
      timing: "Day 5",
      notes:
        "Formal demand letter issued; gives 10 working days to settle before legal action.",
    },
    {
      step: "4",
      action: "Optional Pre-Legal Call/Email",
      timing: "Day 10–12",
      notes: "Last attempt to settle amicably before court filing.",
    },
    {
      step: "5",
      action: "Legal Escalation",
      timing: "Day 10+ after demand letter",
      notes:
        "File in court; include all reminders, invoices, and correspondence as evidence.",
    },
  ],
};

export default img;
